/**
 * Profile validation utility for course registration
 * Validates that user has required contact information before booking
 */

/**
 * Validates if user profile has required contact information for course registration
 * @param {Object} user - User object from AuthContext or UserContext
 * @returns {Object} - Validation result with isValid boolean and missing fields array
 */
export const validateUserProfileForRegistration = (user) => {
  if (!user) {
    return {
      isValid: false,
      missingFields: ['profile'],
      message: 'User profile not found',
    }
  }

  const missingFields = []

  // Check for WeChat ID or Phone Number (at least one is required)
  const hasWeChatId = user.weChatId && user.weChatId.trim() !== ''
  const hasPhoneNumber = user.phoneNumber && user.phoneNumber.trim() !== ''

  if (!hasWeChatId && !hasPhoneNumber) {
    missingFields.push('contact')
  }

  const isValid = missingFields.length === 0

  return {
    isValid,
    missingFields,
    message: isValid ? 'Profile is complete for registration' : 'Please add a WeChat ID or phone number to complete course registration',
  }
}

/**
 * Generates redirect URL for returning to the current page after profile update
 * @param {Object} location - React Router location object
 * @returns {string} - Current path for redirect
 */
export const generateReturnUrl = (location) => {
  return location.pathname + (location.search || '') + (location.hash || '')
}

/**
 * Creates navigation options for profile edit with return location state
 * @param {string} returnUrl - URL to return to after profile update
 * @returns {Object} - Navigation options with state for profile redirect
 */
export const createProfileEditNavigation = (returnUrl) => {
  const encodedReturnUrl = encodeURIComponent(returnUrl)
  return {
    pathname: '/profile',
    search: `?edit=true&return=${encodedReturnUrl}`,
    state: {
      returnUrl,
      openEdit: true,
      message: 'Please update your contact information to continue with course registration',
    },
  }
}
